import type { ReactNode } from "react";
import { Link } from 'react-router-dom';

type IconTextProps = {
	faIconName?: string;
	icon?: ReactNode;
	iconSize?: "small" | "large"
	text?: string;
	href?: string;
	inline?: boolean;
}

const IconText = ({
	text,
	iconSize = "small",
	faIconName,
	icon,
	href,
	inline,
}: IconTextProps) => {
	const iconDimension = iconSize === "large" ? "1.5em" : "1em";
	const renderedIcon = icon ? (
		<span style={{ display: "inline-flex", width: iconDimension, height: iconDimension, alignItems: "center", justifyContent: "center" }}>
			{icon}
		</span>
	) : (
		faIconName ? <i className={`icon fa ${faIconName} ${iconSize === "large" ? "fa-xl" : "fa-sm"}`}/> : null
	);
	const element = (
		<div style={{ ...inline && { display: "inline-block" } }}>
	    <span style={{ display: "inline-block", minWidth: "30px" }}>
	      {renderedIcon}
	    </span>
	    <span>{text || ""}</span>
    </div>
	);
	if (!href) {
		return element;
	}
	return <Link to={href}>{element}</Link>;
};

export default IconText;
